import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import { AffirmationWithCategory } from '../../../../interfaces/tell_me/affirmationWithCategory.types';
import { v4 as uuidv4 } from 'uuid';
import Checkbox from '@material-ui/core/Checkbox';
import { getAllCategories } from '../../../../api/api';
import { Category } from '../../../../interfaces/tell_me/category.types';
import { ListItem } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';


interface Props {
    handleClose: VoidFunction,
    onSubmit: (affirmation: AffirmationWithCategory) => void,
    open: boolean,
}

function AddAffirmationDialog(props: Props) {

    const [text, setText] = useState('');
    const categories = useSelector((state: AppState) => state.categories);
    const [selectedCategories, setSelectedCategories] = useState<Array<Category>>([]);

    const handleSubmit = () => {
        if (text !== '' && categories.length > 0) {
            const affirmation: AffirmationWithCategory = {
                categoryIds: selectedCategories.map(e => e.id),
                id: uuidv4(),
                text: text,
            }
            setSelectedCategories([]);
            props.onSubmit(affirmation);
        }
    }

    const handleClose = () => {
        setSelectedCategories([]);
        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Add an Affirmation</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter all fields to add an affirmation. Select categories to add.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="text"
                    type="email"
                    fullWidth
                    onChange={(val) => setText(val.target.value)}
                />
                <Box height={15} />

                {categories.map((category) => {
                    let selected = false;
                    if (selectedCategories.map(e => e.id).includes(category.id)) {
                        selected = true;
                    }

                    return (
                        <ListItem>
                            <Checkbox
                                checked={selected}
                                onChange={() => {
                                    if (!selected) {
                                        const list = [...selectedCategories, category];
                                        setSelectedCategories(list);
                                        return;
                                    }
                                    else {
                                        let indexToRemove = -1;

                                        for (let index = 0; index < selectedCategories.length; index++) {
                                            if (selectedCategories[index].id === category.id) {
                                                indexToRemove = index;
                                            }
                                        }
                                        if (indexToRemove !== -1) {
                                            const list = [...selectedCategories];
                                            list.splice(indexToRemove, 1);
                                            setSelectedCategories(list);
                                        }
                                    }
                                }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                            {category.name}
                        </ListItem>

                    )
                })}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary">
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default AddAffirmationDialog;